import { FCX, cssX, IDropdownItem } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { ReactNode } from "react";

interface ToolSimpleSearchDropdownProps {
    items?: IDropdownItem[];
    isVisible: boolean;
    children?: ReactNode;
}

const ToolSimpleSearchDropdown: FCX<ToolSimpleSearchDropdownProps> = ({
    items,
    isVisible,
    children,
    className,
    testId,
    style,
}) => {

    if (!isVisible) return null;

    if (!items?.length) {
        return (
            <div
                className={cn(
                    cssX("Dropdown"),
                    "ToolSimpleSearchDropdown",
                    className
                )}
                data-testid={testId}
                style={style}
            >
                {children}
            </div>
        );
    }

    return (
        <div
            className={cn(
                cssX("Dropdown"),
                "ToolSimpleSearchDropdown",
                className
            )}
            data-testid={testId}
            style={style}
        >
            <div className={cn(
                cssX("Dropdown__column"),
                "ToolSimpleSearchDropdown__column"
            )}>
                <div className={cn(
                    cssX("Dropdown__column-content"),
                    "ToolSimpleSearchDropdown__grid"
                )}>
                    {(items ?? []).map((item) => (
                        <div
                            key={item.id}
                            className={cn(
                                cssX("Dropdown__row"),
                                "ToolSimpleSearchDropdown__row"
                            )}
                        >
                            {item.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ToolSimpleSearchDropdown;